import * as R from 'ramda'

export default {

    all: state => Object.values(state.entities),

    allByHasMediaProductionRole: (state, getters) => {
        return R.filter(user => user.roles.includes('MEDIA_PRODUCTION'), getters['all'])
    },

    allByCompanyId: (state, getters, rootState, rootGetters) => companyId => {
        // Ohne Unternehmen kann nicht gefiltert werden
        if (R.isNil(companyId)) {
            return []
        }

        // Person zu Benutzer holen
        const person = id => R.defaultTo({}, rootGetters['persons/byId'](id))

        // Benutzer nach dem Unternehmen der zugehoerigen Person filtern
        return getters['all'].filter(user => person(user.person).company === companyId)
    },

    byId: state => id => {
        return state.entities[id]
    }

}


